<script lang="ts" setup>
import { inject, type Ref, ref } from 'vue';

import type { TRegisterHandler } from '@/types/Register.ts';

const name = ref<string>('');
const email = ref<string>('');
const password = ref<string>('');

const registerHandler = inject<TRegisterHandler>('registerHandler', () => void 0);
const isLoading = inject<Ref<boolean>>('isLoading');
</script>

<template>
  <form key="register-form" class="register-form">
    <div class="field register-form__field">
      <label class="label" for="name">Name</label>
      <p class="control has-icons-left has-icons-right">
        <input
          id="name"
          v-model="name"
          class="input is-dark register-form__field__input"
          @invalid="(event) => event.preventDefault()"
        />
        <span class="icon is-small is-left register-form__field__icon">
          <span class="material-icons">person</span>
        </span>
      </p>
    </div>
    <div class="field register-form__field">
      <label class="label" for="email">Email</label>
      <p class="control has-icons-left has-icons-right">
        <input
          id="email"
          v-model="email"
          class="input is-dark register-form__field__input"
          type="email"
          @invalid="(event) => event.preventDefault()"
        />
        <span class="icon is-small is-left register-form__field__icon">
          <span class="material-icons">email</span>
        </span>
      </p>
    </div>
    <div class="field register-form__field">
      <label class="label" for="password">Password</label>
      <p class="control has-icons-left has-icons-right">
        <input
          id="password"
          v-model="password"
          class="input is-dark register-form__field__input"
          type="password"
        />
        <span class="icon is-small is-left register-form__field__icon">
          <span class="material-icons">lock</span>
        </span>
      </p>
    </div>
    <input
      :disabled="isLoading"
      class="button is-dark submit-btn"
      type="button"
      value="Create account"
      @click="registerHandler(name, email, password)"
    />
  </form>
</template>

<style lang="scss" scoped>
.register-form {
  --color-dark: #404654;

  display: grid;
  gap: 1rem;

  &__field__input {
    &:focus + .icon {
      color: var(--color-dark) !important;
    }
  }
}
</style>
